import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO_DATA = {
  '/': {
    title: 'CISO Dynamics | Strategic Cybersecurity Advisory',
    description: 'CISO Dynamics is a premier cybersecurity advisory firm. We partner with executive leadership to navigate complex cybersecurity challenges, strengthen compliance posture, and build enduring security programs.',
  },
  '/services': {
    title: 'Practice Areas | CISO Dynamics',
    description: 'Comprehensive cybersecurity advisory practice areas including compliance, executive advisory, vCISO, program development, vulnerability management, AI governance, and third party risk management.',
  },
  '/approach': {
    title: 'Our Approach | CISO Dynamics',
    description: 'A structured, partnership-driven methodology: Strategy, Design, Implement, and Operate. Every engagement delivers measurable value aligned with your strategic priorities.',
  },
  '/industries': {
    title: 'Industries | CISO Dynamics',
    description: 'Deep cybersecurity expertise across healthcare, financial services, government, defense, energy, aviation, logistics, telecommunications, and other regulated industries.',
  },
  '/insights': {
    title: 'Insights & Thought Leadership | CISO Dynamics',
    description: 'Perspectives on cybersecurity strategy, compliance, governance, and the evolving landscape of enterprise security from CISO Dynamics advisory team.',
  },
  '/contact': {
    title: 'Contact Us | CISO Dynamics',
    description: 'Start a conversation about your cybersecurity challenges. Request a consultation with the CISO Dynamics advisory team. We respond within one business day.',
  },
  '/careers': {
    title: 'Careers | CISO Dynamics',
    description: 'Join the CISO Dynamics team. We are looking for experienced cybersecurity professionals who share our commitment to excellence, integrity, and client impact.',
  },
};

export const PageSEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const basePath = pathname.startsWith('/insights/') ? '/insights' : pathname;
    const seo = SEO_DATA[basePath] || SEO_DATA['/'];

    // For individual articles, customize title
    if (pathname.startsWith('/insights/') && pathname !== '/insights') {
      document.title = `Insights | CISO Dynamics`;
    } else {
      document.title = seo.title;
    }

    // Update meta description
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', seo.description);

    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', seo.title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', seo.description);
  }, [pathname]);

  return null;
};

export default PageSEO;
